export const NAME_SPACE = 'legal_affairs_certification_manage'
export const EDIT = 'edit'
export const FROZEN = 'frozen'
export const HISTORY = 'history'